import * as React from 'react';

const AuthenticityDiamond24 = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M15.352 6.978a.53.53 0 0 1 .563.478l.16 1.346c.03.25.227.446.478.475l1.35.16c.64.077.64 1.004 0 1.08l-1.35.16a.544.544 0 0 0-.478.475l-.16 1.345c-.076.64-1.007.64-1.083 0l-.16-1.345a.545.545 0 0 0-.478-.475l-1.35-.16c-.64-.076-.64-1.004 0-1.08l1.35-.16a.545.545 0 0 0 .478-.475l.16-1.346a.526.526 0 0 1 .52-.478"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M16.554 4.015a3 3 0 0 1 1.825.864l2.719 2.719a3.08 3.08 0 0 1 .061 4.293l-6.629 7.018-.127.127A3.48 3.48 0 0 1 12 20c-.958-.026-1.865-.387-2.53-1.09l-6.63-7.02a3.08 3.08 0 0 1-.043-4.181l.105-.111 2.72-2.72A3 3 0 0 1 7.741 4h8.516l.296.015ZM7.742 5.5a1.5 1.5 0 0 0-1.06.44l-2.72 2.718a1.58 1.58 0 0 0-.03 2.202l6.628 7.02a1.98 1.98 0 0 0 2.88 0l6.628-7.02a1.58 1.58 0 0 0-.03-2.202l-2.72-2.719a1.5 1.5 0 0 0-1.06-.439z"
  }
));
AuthenticityDiamond24.Size = 24;
AuthenticityDiamond24.Title = "AuthenticityDiamond";

export { AuthenticityDiamond24 as default };
